<p-dialog
  [header]="getHeader()"
  [(visible)]="visible"
  [style]="{ width: '100%', maxWidth: '1000px' }"
  [contentStyle]="{ minHeight: 'calc(100vh - 750px)' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
>
  <div class="flex flex-column gap-3">
    <eo-form
      #eoForm
      [config]="getFormConfig()"
      (formSubmit)="onSubmit($event)"
      [submitButtonLoading]="isSubmitLoading()"
      [customFormControls]="{
        hospitalID: hospitalID,
        userID: userID
      }"
    >
      <ng-template
        #hospitalID
        let-formGroup="formGroup"
        let-config="config"
        let-styleClass="styleClass"
      >
        <ng-container [formGroup]="formGroup">
          <app-hospital-dropdown
            [label]="config.label"
            [class]="styleClass"
            [config]="config"
            formControlName="hospitalID"
            placeholder="Επιλέξτε Νοσοκομείο"
            (change)="onHospitalChange($event)"
          />
        </ng-container>
      </ng-template>

      <ng-template
        #userID
        let-formGroup="formGroup"
        let-config="config"
        let-styleClass="styleClass"
      >
      <ng-container [formGroup]="formGroup">
        <app-hospital-user-dropdown
          [label]="config.label"
          [class]="styleClass"
          [config]="config"
          formControlName="userID"
          optionValue ="userID"
          placeholder="Επιλέξτε Διαχειριστή"
          [hospitalId]="hospitalId"
          role="ClinicAdmin"
        />
      </ng-container>
    </ng-template>
    </eo-form>
  </div>
</p-dialog>
